/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementFbInstantRewardedOptions, FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsToJSON, } from './FxIdDomainSettingsAdvertisementFbInstantRewardedOptions';
export function FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedFromJSON(json) {
    return FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementFbInstantRewardedOptions(json)) {
        return FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedToJSON(json) {
    return FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementFbInstantRewardedOptions(value)) {
        return FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementFbInstantOptionsRewarded.js.map